import { post } from '~/plugins/nikan-api'
import _ from 'lodash'
import Endpoints from '@nikan/endpoints'

export const state = {
  salaryPeriods: []
}
export const mutations = {
  prepare(state, list) {
    if (list && Array.isArray(list)) {
      state.salaryPeriods = list
    } else {
      state.salaryPeriods = []
    }
  },
  clear(state) {
    state.salaryPeriods = []
  }
}
export const actions = {
  async refresh({ dispatch, commit, state }, options) {
    options = _.merge({ force: false }, options)

    // clear
    commit('clear')

    var result = await post(Endpoints.getUrl('salaryPeriod.list'))
    if (result.success) {
      commit('prepare', result.data.items)
    }
  },

  clear({ commit }) {
    commit('clear')
  }
}
export const getters = {
  all: state => {
    return state.salaryPeriods
  },
  getById: state => id => {
    return _.head(state.salaryPeriods.filter(x => x.id === id))
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
